
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M9.142 7.976h9v2h-9zM9.142 20h6v2h-6zM18.333 25a2 2 0 1 1-4 0 2 2 0 0 1 4 0M7.785 32.53h9.732v4.016H7.785zM33 26l2.97 7.03L43 36l-7.03 2.97L33 46l-2.97-7.03L23 36l7.03-2.97zM41 22l1.188 2.812L45 26l-2.812 1.188L41 30l-1.188-2.812L37 26l2.812-1.188z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-fields",attrs:{"stroke":"#234652","d":"M9.5 12.312h19v3.732h-19zM12.5 25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm10.667 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.333 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM9.173 31.314h9.542v3.732H9.173zm7.22-6.814a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z"}}),_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#234652","stroke-linejoin":"round","d":"M27 42H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v16.882M34 24l2.97 7.03L44 34l-7.03 2.97L34 44l-2.97-7.03L24 34l7.03-2.97z"}})])
          )
        }
      }
    